/**
 * Animation duration for toast transitions in milliseconds
 */
export const ANIMATION_DURATION = 300; // ms

/**
 * Total padding around the toast stack (top + bottom approximation)
 */
export const TOAST_STACK_PADDING = 48;

/**
 * Height of the expand/collapse button plus its padding
 */
export const EXPAND_BUTTON_HEIGHT_WITH_PADDING = 64;

/**
 * Scroll threshold in pixels from bottom to hide bottom gradient
 */
export const SCROLL_THRESHOLD = 64;

/**
 * Throttle interval for scroll and resize event handlers in milliseconds
 */
export const EVENT_THROTTLE_MS = 16; // ~60fps
